import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { Decimal } from 'decimal.js-light';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MaskService } from '../../../services/mask.service';

import { MaskitoDirective } from '@maskito/angular';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-percentage-exp',
  styleUrls: ['form-percentageExp.component.scss'],
  template: `
    @if (props.label) {
      <label
        for="percentage-exp-{{ field.key }}"
        class="section col-12"
        tabindex="0"
        [innerHTML]="props.label"
      ></label>
    }
    @if (props.prompt) {
      <p class="explanation" tabindex="0" [innerHTML]="props.prompt"></p>
    }
    <mat-form-field floatPlaceholder="auto" class="w-100">
      <mat-label>{{ to.placeholder }}</mat-label>
      <input
        id="percentage-exp-{{ field.key }}"
        matInput
        [maskito]="percentMask"
        [placeholder]="props.placeholder || props.label"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [required]="props.required"
        [defaultValue]="formControl.value || ''"
      />
      @if (props.help) {
        <span
          matTooltip="{{ props.help }}"
          aria-label="help"
          tabindex="0"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'rb-tooltip'"
        >
          <mat-icon class="col-1 help-icon"> help </mat-icon>
        </span>
      }
      @if (
        formControl.hasError('required') && !formControl.hasError('regRequired')
      ) {
        <mat-error>This field is required</mat-error>
      }
      @if (formControl.hasError('regRequired')) {
        <mat-error>
          This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.
        </mat-error>
      }
    </mat-form-field>
  `,
  imports: [
    FormlyModule,
    MaskitoDirective,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
})
export class FormlyPercentageExpComponent extends FieldType implements OnInit {
  private cdRef = inject(ChangeDetectorRef);
  mask = inject(MaskService);

  percentMask;

  ngOnInit() {
    const precision = this.props.decimalPrecision
      ? this.props.decimalPrecision
      : 2;

    setTimeout(() => {
      if (this.formControl.value && this.formControl.value.replace) {
        this.formControl.setValue(
          new Decimal(+this.formControl.value.replace('%', ''))
            .todp(precision)
            .toNumber()
            .toString()
        );
        this.cdRef.detectChanges();
      }
    });

    this.percentMask = this.mask.percentMaskSpecs(precision);
  }
}
